// extracted by mini-css-extract-plugin
export default {"root":"_1yj0S","title":"_15ah_","items":"_1N7Cw"};